// extracted by mini-css-extract-plugin
export default {"fab":"managers_fab__HpA68","bold":"managers_bold__PzTp6","textTrans":"managers_textTrans__XBtUM"};